// extracted by mini-css-extract-plugin
export default {"wrapper":"TC_wrapper__1C29J","bold":"TC_bold__Ukwj3","red":"TC_red__nj9lg","glue":"TC_glue__smHWm"};